/**
 * The two letters an official's avatar falls back to when there is no photograph.
 *
 * It lives in its own module rather than beside the roster table it was written for, because
 * run 29 gave the avatar its own component and three screens draw one: the roster listing, the
 * profile header and the profile card. A shared helper imported from a table component would
 * have made that table a dependency of everything that draws a circle — and, once the table
 * imported the component back, a cycle.
 */

/** Two letters: the first character of the first token and of the last, uppercased. */
export function initialsOf(mediaName: string): string {
  const tokens = mediaName.trim().split(/\s+/).filter(Boolean);
  const first = tokens[0]?.[0] ?? "";
  const last = tokens.length > 1 ? (tokens[tokens.length - 1]?.[0] ?? "") : "";
  return `${first}${last}`.toUpperCase();
}
